import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const TransportList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingTransport', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'Transport'}
            api='secondary'
            showTitle={true}
            title={'Transports'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/transportCrud', 'Create', t('Add')+' '+t('Transport'), row)],
                ['Edit', (row) => newRoute('containerControl/transportCrud', 'Edit', t('Edit')+' '+t('Transport'), row)],
                ['Copy', (row) => newRoute('containerControl/transportCrud', 'Copy', t('Copy')+' '+t('Transport'), row)]
            ])}
        />
    )
}